import { safeDefineElement } from '@/scripts/core/global'
import { LocalizationForm } from '@/scripts/optional/localization-form'

safeDefineElement(LocalizationForm)
